module.exports = __webpack_public_path__ + "img/e5c3474.png";